import { Defaults } from "./Defaults";
import { QuoteCoverageDetails } from "./QuoteCoverageDetails";

export enum PaymentOptions {
  None = 0,
  Monthly = 1,
  Annual = 2,
  FourPay = 3,
}
export class QuoteInsurance {
  workitemId = "";
  coverageAmount = 0;
  deductibleAmount = 0;
  deductibleAmountText = "";
  paymentOption = PaymentOptions.None;
  dueToday = 0;
  hasReplacementCost = Defaults.getInstance().hasReplacementCost;
  hasWaterSewer = Defaults.getInstance().hasWaterSewer;
  annualAmount = 0;
  monthlyAmount = 0;
  fourPayAmount = 0;
  installmentAmount = 0;
  sku = "";
  processingFeeSku = "";
  retailPremium = 0;
  transactionId = 0;
  policyNumber = 0;
  serviceFee = 0;
  numberOfPayments = 0;
  quoteCoverageDetails = new QuoteCoverageDetails();
  rentersApiOk = true;
  hasPaymentErrors = false;
  policyTerms: any[] = [];
  monthlyProcessingFee = 0;
  processingFee = 0;
  discount = 0;
  installmentDiscount = 0;
  fullTermTotal = 0;
  installmentTotal = 0;
  term = "";
  coverageTypes: any[] = [];
}
